module.exports = __webpack_public_path__ + "img/charts-pie-and-bars-dark.7ba2e407.svg";